import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleGetStarted = () => {
    // This will be updated when we add routing
    window.location.hash = '#converter';
  };

  return (
    <header className="header">
      <div className="landing-container-wide">
        <div className="header-content">
          <div className="logo" onClick={() => window.location.hash = 'home'} style={{ cursor: 'pointer' }}>
            <svg width="32" height="32" viewBox="0 0 32 32" className="logo-icon">
              <defs>
                <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#667eea" />
                  <stop offset="100%" stopColor="#764ba2" />
                </linearGradient>
              </defs>
              <rect x="4" y="4" width="24" height="24" rx="4" fill="url(#logoGradient)" />
              {/* Wrench tool */}
              <path d="M12 8l-2 2 1.5 1.5L10 13l2 2 1.5-1.5L15 15l2-2-1.5-1.5L17 10l-2-2-1.5 1.5L12 8z" fill="white" />
              {/* Screwdriver tool */}
              <path d="M18 18l2 2v4l-2-2-4-4 2-2h2z" fill="white" opacity="0.8" />
              {/* Gear */}
              <circle cx="21" cy="11" r="2" fill="white" opacity="0.6" />
              <path d="M21 9v4M19 11h4" stroke="white" strokeWidth="0.5" opacity="0.6" />
            </svg>
            <span className="logo-text">Utility Tools</span>
          </div>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li><a href="/#features" className="nav-link">Features</a></li>
              <li><a href="/#how-it-works" className="nav-link">How It Works</a></li>
              <li><a href="#faq" className="nav-link" onClick={(e) => { e.preventDefault(); window.location.hash = 'faq'; }}>FAQ</a></li>
              <li><a href="#feedback" className="nav-link" onClick={(e) => { e.preventDefault(); window.location.hash = 'feedback'; }}>Feedback</a></li>
            </ul>
          </nav>

          <div className="header-actions">
            <button className="btn btn-primary" onClick={handleGetStarted}>
              Get Started
            </button>
          </div>

          <button className="mobile-menu-toggle" onClick={toggleMenu}>
            <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;